import {networkError, uiInfo, uiSuccess} from "./ui";
import {deleteProjectPhoto$, getProjectPhoto$} from "../services/projects";
import {getBidPhoto$} from "../services/bids";
import {postFile$} from "../services/files";
import {setUploadFileStatus} from "./files";
import {BID, PROJECT} from "../services";
import {APIError} from "../common/errors";

export const ADD_PHOTOS = 'ADD_PHOTOS';
export const addPhotos = (photos) => ({ type: ADD_PHOTOS, payload: photos });

const embedPhotoMetadata = (photo) => {
  photo = photo || [];
  return photo.map(file => ({
    metadata: {
      path: '/',
      name: '__photo',
      // mimetype: file.type
    },
    file: file,
    onSuccess: file.onSuccess
  }));
};

export const getBidPhoto = ({id}) => async (dispatch, getState) => {
  try {
    const { response, status } = await getBidPhoto$({ bidId: id }).toPromise();
    if (!response) return null;
    dispatch(addPhotos([{...response, id}]));
  } catch (error) {
    const { response, status } = error;
    if (status === 404 && response.code === 'photo_not_found') {
      dispatch(addPhotos([{ id, url: null }]));
    } else {
      dispatch(networkError({...error, number: '10145-'+error.status}));
    }
  }
};

export const getProjectPhoto = ({id}) => async (dispatch, getState) => {
  try {
    const { response, status } = await getProjectPhoto$({ projectId: id }).toPromise();
    if (!response) return null;
    dispatch(addPhotos([{...response, id}]));
  } catch (error) {
    const { response, status } = error;
    if (status === 404 && response.code === 'photo_not_found') {
      dispatch(addPhotos([{id, url: null}]));
    } else {
      dispatch(networkError({...error, number: '10147-'+error.status}));
    }
  }
};

export const deleteProjectPhoto = ({id}) => async (dispatch, getState) => {
  try {
    const { response, status } = await deleteProjectPhoto$({ projectId: id }).toPromise();
    dispatch(getProjectPhoto({id}));
  } catch (error) {
    dispatch(networkError({...error, number: '10148-'+error.status}));
  }
};

export const uploadBidPhoto = (id, photo) => uploadPhoto(BID, id, photo);

export const uploadProjectPhoto = (id, photo) => uploadPhoto(PROJECT, id, photo);

const uploadPhoto = (type, id, photo) =>
  /**
   * Upload an architectural photo for a bid or project to replace the existing photo or placeholder.
   * This function operates identically to uploadFiles with a few simplifications - a bid or project
   * photo will always be located at the document root and always named as '__photo', so this function
   * defaults the uploaded file to be specified as such. Additionally, there is no precedent for
   * project sub-documents to contain their own photos, so sub-document IDs have been removed from
   * the function signature.
   * @param type BID or PROJECT constant
   * @param id Document ID to associate photo with
   * @param photo A file array, expecting a single architectural photo
   * @returns {Function}
   */
  doUploadPhoto({
    type,
    id,
    files: embedPhotoMetadata(photo)
  });

const doUploadPhoto = (payload) => async (dispatch, getState) => {
  try {
    let { files, type, id } = payload;
    for (let fileData of files) {
      try {
        let { metadata, file, onSuccess } = fileData;
        dispatch(uiInfo('Uploading file'));
        dispatch(setUploadFileStatus({metadata, type, id, loading: true}));
        let { response, status } = await postFile$({ type, id, metadata, file }).toPromise();
        if (onSuccess) onSuccess();
        switch (type) {
          case PROJECT:
            dispatch(getProjectPhoto({id}));
            break;
          case BID:
            dispatch(getBidPhoto({id}));
            break;
          default:
            dispatch(networkError(new APIError("cannot construct refresh action; invalid document type")));
        }
        dispatch(setUploadFileStatus({metadata, type, id, loading: false}));
        dispatch(uiSuccess('File upload successful'));
      } catch (error) {
        dispatch(networkError({...error, number: '10054-'+error.status}));
      }
    }
  } catch (error) {
    dispatch(networkError({...error, number: '10055-'+error.status}));
  }
};




// WEBPACK FOOTER //
// ./src/actions/photos.js